// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"690":"5b049fc25215a375061b","955":"1f67b5adb1f097b973b7"}[chunkId] + ".bundle.js";
};